import router from '@/router/router'

export const openWindow = (params: any) => {
  const { href } = router.resolve(params)
  window.open(href, '_blank')
}
